/** 个人资料弹框样式配置（单位 px，在此调节） */
export const ProfileConfig = {
  /** 弹框宽度 */
  modalWidthPx: 600,
  /** 输入框、多行文本框圆角 */
  inputBorderRadiusPx: 4,
  /** 头像展示尺寸（宽高一致） */
  avatarSizePx: 72,
  /** 保存按钮高度 */
  saveButtonHeightPx: 42,
  /** 表单项之间的行间距（每项为 label 在上、输入框在下） */
  formRowGapPx: 10,
  /** 保存按钮与上方表单项的间距 */
  saveButtonTopGapPx: 30,
} as const;
